import React, { Component } from 'react';

class SettingsPage extends Component {
    render() {
        return (
            <div>settings</div>
        );
    };
}

export default SettingsPage;